import { Empty } from 'antd'
import { FC, useRef, useState } from 'react'
import Button from '@UI/New/Button'
import { PlusCircleFilled } from '@ant-design/icons'
import classes from './index.module.css'
import LinksPurchasesList, {
  PurchasesLinksListHandle,
} from './components/PurchasesLinksList/PurchasesLinksList'
import CreateLinkModal from './components/CreateLinkModal/CreateLinkModal'
import useFullLeadModalAccess from '../../hooks/useFullLeadModalAccess'
import type { LeadProfileLead } from '../../LeadProfileModal.types'

interface LinksPurchasesBlockProps {
  lead: LeadProfileLead
  currentLeadFunnelId?: number
  excludedClassIds: number[]
  excludedDirectionIds: number[]
  /** Перед обновлением списка ссылок — полный рефетч карточки заявки (статус воронки и т.д.). */
  onSyncLeadBinding?: () => void | Promise<void>
  isSyncingLeadBinding?: boolean
}

const LinksPurchasesBlock: FC<LinksPurchasesBlockProps> = ({
  lead,
  currentLeadFunnelId,
  excludedClassIds,
  excludedDirectionIds,
  onSyncLeadBinding,
  isSyncingLeadBinding,
}) => {
  const hasFunnel = !!currentLeadFunnelId && currentLeadFunnelId > 0
  const access = useFullLeadModalAccess()
  const [stateModal, setStateModal] = useState<{
    open: boolean
    type?: 'create'
  }>({
    open: false,
    type: 'create',
  })

  const linksListRef = useRef<PurchasesLinksListHandle>(null)
  return (
    <div className={classes.card}>
      <div className={classes.cardHeader}>
        <div className={classes.cardTitleCol}>
          <p className={classes.cardEyebrow}>Ссылки</p>
          <p className={classes.cardTitle}>Ссылки на покупки</p>
        </div>
        <div className={classes.cardHeaderActions}>
          {access.canManagePurchaseLinks && hasFunnel ? (
            <Button
              variant="action"
              color="secondary"
              onClick={() => setStateModal({ open: true, type: 'create' })}
              leftContent={
                <PlusCircleFilled
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                />
              }
            >
              Добавить ссылку на покупку
            </Button>
          ) : null}
        </div>
      </div>
      {!hasFunnel && access.canManagePurchaseLinks ? (
        <p className={classes.createHint}>
          Без выбранной воронки создание ссылок на покупки недоступно.
        </p>
      ) : null}
      <div className={classes.cardContent}>
        {!!lead.id ? (
          <LinksPurchasesList
            ref={linksListRef}
            lead={lead}
            isSyncingLeadBinding={isSyncingLeadBinding}
            onSyncLeadBinding={onSyncLeadBinding}
          />
        ) : (
          <Empty
            className={classes.empty}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={'Лид не найден'}
          />
        )}
      </div>
      {/* Modals */}
      {hasFunnel ? (
        <CreateLinkModal
          lead={lead}
          currentLeadFunnelId={currentLeadFunnelId}
          excludedClassIds={excludedClassIds}
          excludedDirectionIds={excludedDirectionIds}
          open={stateModal.open && stateModal.type === 'create'}
          onClose={() => setStateModal({ open: false })}
          onSuccess={() => {
            void (async () => {
              try {
                if (onSyncLeadBinding) await onSyncLeadBinding()
              } finally {
                linksListRef.current?.refetchQuery()
                setStateModal({ open: false })
              }
            })()
          }}
        />
      ) : null}
    </div>
  )
}

export default LinksPurchasesBlock
